import {styled} from "@mui/material/styles";
import StepConnector, {stepConnectorClasses} from "@mui/material/StepConnector";
import {StepIconProps} from "@mui/material/StepIcon";
import * as React from "react";
import Check from "@mui/icons-material/Check";
import {AccountCircle, AttachMoney, UploadFileSharp} from "@mui/icons-material";
import Paper from "@mui/material/Paper";

export const renderTypeIdentificationDescription = (type: string): string => {
    switch (type) {
        case "4":
            return "TARJETA DE IDENTIDAD"
        case "1":
            return "CEDULA"
        case "5":
            return "CEDULA EXTRANJERIA"
        case "3":
            return "NIT"
        case "2":
            return "PASAPORTE"
        default:
            return ""
    }
}

export const renderTypeIdentification = (name: string): string => {
    switch (name.toUpperCase()) {
        case "TARJETA DE IDENTIDAD":
            return "4";
        case "CEDULA":
            return "1";
        case "CEDULA EXTRANJERIA":
            return "5";
            //VOLVER A PONER NIT
        case "NIT":
            return "3";
        case "PASAPORTE":
            return "2";
        default:
            return "";
    }
}

export const ColorlibConnector = styled(StepConnector)(({theme}) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 16,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor:
                'rgb(110, 226, 224)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor:
                'rgb(110, 226, 224)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#00908E',
        borderRadius: 1,
    },
}));

export const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({theme, ownerState}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#00908E',
    zIndex: 1,
    color: '#fff',
    width: '35px',
    height: '35px',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        backgroundColor:
            'rgb(34, 221, 218)',
        boxShadow: '#00908E',
    }),
    ...(ownerState.completed && {
        backgroundColor:
            'rgb(110, 226, 224)',
    }),
}));

export const Item = styled(Paper)(({theme}) => ({
    padding: theme.spacing(4),
    textAlign: 'center',
}));


